document.addEventListener('DOMContentLoaded', () => {
  const sticky = document.querySelector('[data-nv-sticky]');
  const heroCta = document.querySelector('[data-nv-hero-cta]');
  if (sticky && heroCta && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => sticky.classList.toggle('is-visible', !entry.isIntersecting));
    }, { threshold: 0.15 });
    observer.observe(heroCta);
  }
  document.querySelectorAll('.nv-mobile-nav a').forEach((link) => {
    link.addEventListener('click', () => {
      const details = link.closest('details');
      if (details) details.removeAttribute('open');
    });
  });

  document.querySelectorAll('[data-nv-scroll]').forEach((el) => {
    el.addEventListener('click', (event) => {
      const target = document.querySelector(el.getAttribute('href'));
      if (target) {
        event.preventDefault();
        target.scrollIntoView({behavior:'smooth', block:'start'});
      }
    });
  });
});
